import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';

import { Location } from '../model/index';

@Component({
    selector: 'flo-location',
    templateUrl: './location.component.html',
    styleUrls: ['./location.component.scss'],
})
export class LocationComponent {
    @Output() public locationChange: EventEmitter<Location> = new EventEmitter<Location>();
    @Output() public placeChange: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('loc') public locationInput: NgModel;
    // https://developers.google.com/places/supported_types
    @Input() public placeTypes: string[] = ['(regions)'];
    @Input() public required: boolean = true;
    @Input() public requirePlace: boolean = true;
    @Input() public disabled: boolean = false;
    @Input() public isSubmitted: boolean = false;
    @Input() public formatLocation: boolean = true;

    private _location: Location = new Location();
    @Input()
    set location(location: Location) {
        this._location = location || new Location();
    }

    get location(): Location {
        return this._location;
    }

    public isValid(): boolean {
        this.isSubmitted = true;
        return this.locationInput && this.locationInput.valid;
    }

    public getValidIf(): boolean {
        if (this.required &&
            (
                (this.requirePlace && !this.location.googlePlaceId) ||
                (!this.requirePlace && !this.location.name)
            )
        ) {
            return false;
        }

        return true;
    }

    public reset(): void {
        this.isSubmitted = false;
        this.location = null;

        if (this.locationInput) {
            this.locationInput.reset();
        }
    }

    public onPlaceChange(googlePlace: any): void {
        this.location.fillFromGooglePlace(googlePlace);
        this.locationChange.emit(this.location);
        this.placeChange.emit(googlePlace);
    }

    public onClearLocation(): void {
        this.onPlaceChange(null);
    }
}
